import history from '@src/utils/history';
import {useMappedState /* , useDispatch */} from 'redux-react-hook';

export default (fn, deps, module) => {
  if (typeof fn === 'string') {
    module = fn;
    fn = null;
  }
  if (typeof deps === 'string') {
    module = deps;
    deps = null;
  }
  if (typeof fn !== 'function') {
    deps = fn;
    fn = null;
  }
  if(deps === null) {
    deps = undefined;
  }
  

  return useMappedState(
    fn ||
    (state => {
      const path = module || history.location.pathname;
      state = state.toJS();
      return {
        ...state[path],
        root: state.root
      };
    }),
    deps
  );
};
